import { Section } from '../layout/Section';
import { Card } from '../ui/Card';
import { Icon } from '../ui/Icon';
import { Reveal } from '../ui/Reveal';
import { comparison } from '../../data/landing';
import styles from './Comparison.module.css';

function Column({ data, tone, icon, badgeClass, className }) {
  return (
    <Card elevation="raised" className={`${styles.card} ${className ?? ''}`}>
      <h3 className={`${styles.title} u-h3`}>{data.title}</h3>
      <ul>
        {data.items.map((item) => (
          <li key={item} className={styles.row}>
            <span className={styles.text}>{item}</span>
            <span className={`${styles.badge} ${badgeClass}`}>
              <Icon name={icon} size={22} label={tone} />
            </span>
          </li>
        ))}
      </ul>
    </Card>
  );
}

export function Comparison() {
  return (
    <Section spacing="tight">
      <Reveal className={styles.grid} variant="scale">
        <Column
          data={comparison.traditional}
          tone="Not supported"
          icon="close"
          badgeClass={styles.no}
        />
        <Column
          data={comparison.nimblepark}
          tone="Supported"
          icon="check-circle"
          badgeClass={styles.yes}
          className={styles.win}
        />
      </Reveal>
    </Section>
  );
}
